export default __webpack_public_path__ + "static/media/Taskrabbit.3f86f0f7.png";